module.exports = __webpack_public_path__ + "img/interactive-hero-slider-chevy.42585896.png";